import icons from '../../markons/markons'
import Icon from './Icon'
import kb from '../kb'
import cn from 'classnames'

interface PaymentData {
    bill_total: number
    pay_total: number
}

interface PaymentStatusIconProps extends PaymentData {
    currency?: string
    instant_quote_applied: boolean
}

type PayInfo = {
    paymentStatus: string
    iconName: string
    cssColor: string
}

export function getPaymentInfo(data: PaymentData): PayInfo {
    // console.log(data.booking_number,data.bill_total,data.pay_total)
    if(data.bill_total === data.pay_total) {
        if(data.bill_total === 0) {
            return {
                paymentStatus: 'not-set',
                iconName: icons.ionMinusRound,
                cssColor: 'var(--clr-vib-payment-not-set)',
            }
        }
        return {
            paymentStatus: 'paid',
            iconName: icons.faCheckCircle,
            cssColor: 'var(--clr-vib-payment-paid)',
        }
    } else if(data.bill_total > data.pay_total) {
        if(data.pay_total > 0) {
            return {
                paymentStatus: 'partial',
                iconName: icons.miscPayPartial,
                cssColor: 'var(--clr-vib-payment-partial)',
            }
        }
        return {
            paymentStatus: 'unpaid',
            iconName: icons.faTimesCircle,
            cssColor: 'var(--clr-vib-payment-unpaid)',
        }
    }
    return {
        paymentStatus: 'overpaid',
        iconName: icons.faCheckCircle,
        cssColor: 'var(--clr-vib-payment-overpaid)',
    }
}

const status2text: Record<string, string> = {
    paid: 'Paid',
    partial: 'Partial',
    unpaid: 'Unpaid',
    overpaid: 'Overpaid',
    'not-set': 'Missing',
}

const PaymentStatusIcon: React.FC<PaymentStatusIconProps> = data => {
    const info = getPaymentInfo(data)

    return <Icon name={info.iconName}
        className={cn(`payment--${info.paymentStatus}`, data.instant_quote_applied ? 'payment--instant-quote-applied' : null, 'payment-icon')}
        title={`Paid ${kb.formatCurrencyIntl(data.pay_total, data.currency)} of ${kb.formatCurrencyIntl(data.bill_total, data.currency)}` + (data.instant_quote_applied ? ' (instant quote)' : '')} />
}

export const PaymentStatusText: React.FC<PaymentStatusIconProps> = data => {
    const info = getPaymentInfo(data)

    return (
        <span className={cn('payment-txt', `payment-txt--${info.paymentStatus}`)}>
            {/*<Icon name={info.iconName}/>*/}
            <span title={`Paid ${kb.formatCurrencyIntl(data.pay_total, data.currency)} of ${kb.formatCurrencyIntl(data.bill_total, data.currency)}`}>{status2text[info.paymentStatus] ?? 'Unknown'}</span>
            {data.instant_quote_applied ? <Icon name={icons.faBolt} title="Instant Quote" /> : null}
        </span>
    )
}

export default PaymentStatusIcon
